"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const IoC = __importStar(require("inversify"));
const system_dsl_module_1 = require("./system-dsl-module");
const compiler_api_1 = require("../../compiler-api");
exports.systemDslModule = new IoC.ContainerModule((bind) => {
    bind(compiler_api_1.DslCompilerModuleSymbol).to(system_dsl_module_1.SystemDslModule);
});
//# sourceMappingURL=di.js.map